import { useScopedAppFlagStore } from '@frontend/scope';
import { SUBSCRIPTION_SETTINGS_FF } from '../constants';

export const useIsSubscriptionSettingsEnabled = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasSubscriptionSettingsFF = getFeatureFlagValue(SUBSCRIPTION_SETTINGS_FF);

  return hasSubscriptionSettingsFF;
};
